/* istanbul ignore file */
import { BigFormRow, FormRow, UpdatePageLayout, FormSection } from 'framework/ui/layout';
import { UpdateForm, TextInput } from 'framework/form';
import { NoteAttachmentUploaderInput } from 'domain/shared/artifact/input';
import IsFinalChangesToggle from 'domain/finance/invoice/shared/input/IsFinalChanfesToggle';
import useInvoiceService from 'domain/finance/invoice/useInvoiceService';
import { useInvoiceUrl } from 'domain/finance/invoice/shared/useInvoiceRouting';
import UpdateInvoiceBreadcrumbs from 'domain/finance/invoice/createupdate/Update/Breadcrumbs';

const UpdateInvoicePage = () => {
  const { getUpdateValidationSchema, getById, update } = useInvoiceService();
  const { getSingleEntityUrl } = useInvoiceUrl();

  const getDataFunc = async (id: string) => {
    const data = await getById(id);
    const hasInvoiceDocument = !!data.invoiceDocumentId;

    return {
      invoiceDocumentId: hasInvoiceDocument ? [data.invoiceDocumentId] : null,
      invoiceNumber: data.invoiceNumber,
      isFinalChanges: data.isFinalChanges,
      hasInvoiceDocument,
    };
  };

  return (
    <UpdateForm
      submitFormFunc={update}
      getDataFunc={getDataFunc}
      afterSubmit={{
        redirect: getSingleEntityUrl(),
        message: 'You are awesome! The Invoice has been successfully updated.',
      }}
      getValidationSchemaFunc={getUpdateValidationSchema}
    >
      <UpdatePageLayout breadcrumbs={<UpdateInvoiceBreadcrumbs />} title="Edit: Invoice Document">
        <FormSection>
          <FormRow>
            <TextInput source="invoiceNumber" label="Invoice number" />
          </FormRow>
          <BigFormRow>
            <NoteAttachmentUploaderInput label="Invoice document" source="invoiceDocumentId" />
            <IsFinalChangesToggle source="isFinalChanges" />
          </BigFormRow>
        </FormSection>
      </UpdatePageLayout>
    </UpdateForm>
  );
};

export default UpdateInvoicePage;
